/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
export interface FilterCheckmarkProps extends React.SVGAttributes<SVGElement> {
size?: string;
}
const FilterCheckmark: React.SFC<FilterCheckmarkProps> = ({size, ...props}) => (
  <svg viewBox="0 0 14 12" fill="currentColor" width={ size || "1em" } height={ size || "1em" } {...props}>
    <path d="M6.472637 8.62615l-1.903392.16844.882734-1.04928 1.020658.88084zm5.075157-8.1268c.53502-.63596 1.432014-.66885 2.003491-.07346.571477.5954.601031 1.59361.06601 2.22958L5.756011 12 .548875 7.50616C-.06974 6.97228-.182322 5.98141.297416 5.29299c.479738-.68843 1.370128-.81371 1.988743-.27984l3.16582 2.73216L11.547794.49935z"
      fill="currentColor" />
  </svg>
);
FilterCheckmark.displayName = 'FilterCheckmark';
export default FilterCheckmark;
/* tslint:enable */
/* eslint-enable */
